import {createContext, useContext} from 'react'

import type Artwork from '../../webgl/Artwork'
import type {BrandedDividerRegistration, DitherRegistration, EnterpriseHeroRegistration} from './WebGLContext.types'

export type {
  BrandedDividerParams,
  BrandedDividerRegistration,
  DitherParams,
  DitherRegistration,
  EnterpriseHeroRegistration,
} from './WebGLContext.types'

export type WebGLType = Artwork | null

type WebGLContextType = {
  registerDither: (registration: DitherRegistration) => void
  unregisterDither: (id: string) => void
  registerBrandedDivider: (registration: BrandedDividerRegistration) => void
  unregisterBrandedDivider: (id: string) => void
  registerEnterpriseHero: (registration: EnterpriseHeroRegistration) => void
  unregisterEnterpriseHero: (id: string) => void
}

export const WebGLContext = createContext<WebGLContextType | null>(null)
export const WebGLArtworkContext = createContext<Artwork | null>(null)

export const useWebGLContext = () => {
  const context = useContext(WebGLContext)!
  const artwork = useContext(WebGLArtworkContext)

  return {...context, artwork}
}
